import * as React from 'react';

import * as ramda from 'ramda';

import * as Schema from 'nutshell-core/schema';
import type {CoreEntityType, FilterObject, EntityListViewType} from 'nutshell-core/types';
import {getDisplayName} from 'nutshell-core/utils';

type Props = {
    currentView: EntityListViewType;
    activeFilters: FilterObject[];
    schema: Schema.Properties;
    entityType: CoreEntityType;
    addFilters: (arg1: FilterObject) => any;
    updateFilter: (arg1: FilterObject, arg2: FilterObject) => any;
    removeFilters: (arg1: FilterObject[]) => any;
};

/*
Higher order component responsible for adjusting the stageset schema field
in order to make it unclearable and single select
 */
export function adjustStagesetSchemaField(WrappedComponent: React.ComponentType<any>) {
    return class HOC extends React.PureComponent<Props> {
        static displayName = `HOC(${getDisplayName(WrappedComponent)})`;

        render() {
            const schema =
                ramda.isEmpty(this.props.schema) || this.props.currentView !== 'board'
                    ? this.props.schema
                    : {
                          ...this.props.schema,
                          stageset: {
                              ...this.props.schema.stageset,
                              nullOptionText: undefined,
                              unclearable: true,
                              isSingleSelect: true,
                          },
                      };

            return <WrappedComponent {...this.props} schema={schema} />;
        }
    };
}
